<template>
    <div class="header-class">
            <div class="row">
                <div style="width:100%; float: left; text-align: center;">
                    <router-link to="/">
                        <img  
                            class="headerImageClass"
                            alt="Don Quijote Recepciones" 
                            src="https://presupuesto.donquijoterecepciones.com/assets/logo-white.png">
                    </router-link>
                </div>
            </div>
            
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>

    .headerImageClass {
        opacity: 1.0; top: 10px; position: relative; width: 30%;
    }

    @media screen and (max-width: 600px) {

        .headerImageClass {
            opacity: 1.0; top: 10px; position: relative; width: 90%;
        }


  }
</style>



// WEBPACK FOOTER //
// src/components/Header/Index.vue